import { render } from "./platformSettingsother.vue?vue&type=template&id=babc7a38"
import script from "./platformSettingsother.vue?vue&type=script&lang=js"
export * from "./platformSettingsother.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__